// components/LoadingLogo.js
import React from "react";
import "./LoadingLogo.css";
import { Flex } from "@chakra-ui/react";

const LoadingLogo = () => {
  return (
    <Flex
      className="logo-wrapper"
      width={["60vw", "200px"]}
      height={["60vw", "200px"]}
      align="center"
      justify="center">
        <svg
          preserveAspectRatio="xMidYMid meet"
          style={{ width: "100%", height: "auto" }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -15 263 180"
          fill="none">
            <path className="fire-move" fillRule="evenodd" clipRule="evenodd" d="M68.1763 53.6276C36.0274 37.4291 26.0967 30.4094 56.046 15.3539C70.4025 8.13659 60.0036 -3.46062 64.7765 0.988394C68.8322 4.76896 72.225 9.36058 70.7547 13.9104C68.5723 20.664 62.0226 23.4022 58.7627 27.6419C53.4118 34.601 52.908 41.9144 68.1763 53.6276Z" fill="#FEFEFE"/>
            <path className="fade-text" d="M4.30763 68.3081V96.5379H80.5721V99.5899H1V49.5517H31.2768V52.7943H4.30763V65.0655H59.5502V68.3081H4.30763ZM154.292 65.0655C156.285 65.0655 157.981 64.4931 159.381 63.3488C160.78 62.2042 161.48 60.6575 161.48 58.7076C161.48 56.9699 160.748 55.5498 159.285 54.4477C157.822 53.3456 156.158 52.7947 154.292 52.7947H90.1761V65.0659H154.292L154.292 65.0655ZM117.082 68.3081L164.724 99.5899H159.508L111.867 68.3081H90.1769V99.5899H86.8692V49.5517H154.229C157.07 49.5517 159.508 50.3569 161.544 51.9677C163.706 53.7054 164.788 55.9096 164.788 58.5802C164.788 61.5048 163.77 63.8575 161.734 65.6378C159.688 67.4181 157.187 68.3085 154.218 68.3085H117.083L117.082 68.3081ZM240.161 65.0655C242.154 65.0655 243.85 64.4931 245.25 63.3488C246.649 62.2042 247.349 60.6575 247.349 58.7076C247.349 56.9699 246.617 55.5498 245.154 54.4477C243.691 53.3456 242.027 52.7947 240.161 52.7947H176.045V65.0659H240.161L240.161 65.0655ZM202.952 68.3081L250.593 99.5899H245.377L197.736 68.3081H176.046V99.5899H172.738V49.5517H240.098C242.939 49.5517 245.377 50.3569 247.413 51.9677C249.575 53.7054 250.657 55.9096 250.657 58.5802C250.657 61.5048 249.639 63.8575 247.604 65.6378C245.558 67.4181 243.056 68.3085 240.087 68.3085H202.952L202.952 68.3081ZM258.607 49.5517H261.915V99.5899H258.607V49.5517Z" fill="#FEFEFE" stroke="#FEFEFE" strokeWidth="0.288" strokeMiterlimit="2.61313"/>
            <text
              x="50%"
              y="78%"
              textAnchor="middle"
              fontSize="16"
              fill="#fff"
              className="fade-text"
            >
              ARTE DEL FUOCO
            </text>
        </svg>
    </Flex>
  );
};

export default LoadingLogo;
